import { FieldKey } from '../../context/field-keys.js';
/** Σ over floor-suites of `size × pct × 0.01`, rounding to 2 decimals after each accumulation. */
export function calculateTotalItzaArea(items) {
  if (!items?.length) {
    return null;
  }
  let total = 0;
  for (const item of items) {
    const size = item.sizeInLocaleUom || 0;
    const pct = item.itzaPercent || 0;
    total = Number((total + size * pct * 0.01).toFixed(2));
  }
  return total;
}
/** yearly / totalSizeITZA, to 2 decimals; null unless both are > 0. */
export function calculateAskingRentPerItza(askingRentalAmountYearly, totalSizeItza) {
  return totalSizeItza > 0 && askingRentalAmountYearly > 0 ? Number((Number(askingRentalAmountYearly) / Number(totalSizeItza)).toFixed(2)) : null;
}
/**
 * Asking rent per ITZA from the (already-computed) total ITZA size and the yearly asking-rent total.
 * The weighted-area aggregation itself is array-shaped (see {@link calculateTotalItzaArea}) and is
 * driven by the host listener; this rule covers the scalar field relationship.
 */
export const askingRentPerItzaRule = {
  id: 'itza.asking-rent-per-itza.from-yearly-total-size',
  inputs: [FieldKey.AvailAskingRentYearlyTotal, FieldKey.ItzaArea],
  outputs: [FieldKey.AskingRentPerItza],
  formulaVersion: '1.0.0',
  run: ctx => {
    const yearly = ctx.get(FieldKey.AvailAskingRentYearlyTotal);
    const totalItza = ctx.get(FieldKey.ItzaArea);
    ctx.set(FieldKey.AskingRentPerItza, calculateAskingRentPerItza(yearly, totalItza));
  }
};
export const itzaRules = [askingRentPerItzaRule];
